var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.11341 6.45442C1.02262 6.31063 0.977227 6.23877 0.951814 6.1279C0.932729 6.04464 0.932729 5.91331 0.951814 5.83005C0.977227 5.71919 1.02262 5.64732 1.11341 5.50353C1.86365 4.3156 4.09681 1.3125 7.5 1.3125C10.9032 1.3125 13.1364 4.3156 13.8866 5.50353C13.9774 5.64732 14.0228 5.71919 14.0482 5.83005C14.0673 5.91331 14.0673 6.04464 14.0482 6.1279C14.0228 6.23877 13.9774 6.31063 13.8866 6.45442C13.1364 7.64238 10.9032 10.6455 7.5 10.6455C4.09681 10.6455 1.86365 7.64238 1.11341 6.45442Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 7.97884C8.60447 7.97884 9.49984 7.08348 9.49984 5.97892C9.49984 4.87437 8.60447 3.979 7.49992 3.979C6.39536 3.979 5.5 4.87437 5.5 5.97892C5.5 7.08348 6.39536 7.97884 7.49992 7.97884Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.85e69df1747608a54ee6ce1052e061c0.svg";
export { ForwardRef as ReactComponent };